<div
    class="picture medium-padding"
    [ngStyle]="{
        'background-image':
            (pictureToDisplay$ | async)
                ? 'linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url(' + (pictureToDisplay$ | async) + ')'
                : 'linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3))'
    }"
    [class.project-picture]="!(isBuildingNode$ | async)"
    [class.building-picture]="isBuildingNode$ | async"
>
    @if (!bannerTitle) {
        <div class="node-title">
            <h2>
                {{ currentNodeId$ | async | classificationNodeName }}
            </h2>
            @if (location$ | async; as location) {
                <p>
                    {{ location }}
                </p>
            }
        </div>
    } @else {
        <div class="banner" [ngStyle]="{ 'background-color': bannerColor }">
            <div class="title">
                @if (bannerIcon) {
                    <svg-icon [svgStyle]="{ fill: textColor, height: 41, width: 41 }" [src]="bannerIcon" />
                }
                <div class="title-text" [ngStyle]="{ color: textColor }">
                    {{ bannerTitle }}
                </div>
            </div>
        </div>
    }
</div>
